export const formatPassengerCounts = (passengerCounts: {
  ADT: number;
  CHD: number;
  INF: number;
}): string => {
  const parts: string[] = [];

  if (passengerCounts.ADT > 0) {
    parts.push(
      `${passengerCounts.ADT} ${passengerCounts.ADT === 1 ? "Adult" : "Adults"}`,
    );
  }

  if (passengerCounts.CHD > 0) {
    parts.push(
      `${passengerCounts.CHD} ${
        passengerCounts.CHD === 1 ? "Child" : "Children"
      }`,
    );
  }

  if (passengerCounts.INF > 0) {
    parts.push(
      `${passengerCounts.INF} ${
        passengerCounts.INF === 1 ? "Infant" : "Infants"
      }`,
    );
  }

  return parts.join(", ");
};

// Flight-related utilities
export interface CabinClassOption {
  label: string;
  code: string;
}

export const cabinClassOptions: CabinClassOption[] = [
  { label: "Economy", code: "Y" },
  { label: "Premium Economy", code: "S" },
  { label: "Business", code: "C" },
  { label: "Premium Business", code: "J" },
  { label: "First class", code: "F" },
  { label: "Premium First", code: "P" },
];

export function getCabinLabel(code?: string): string {
  const foundOption = cabinClassOptions.find((c) => c.code === code);
  return foundOption?.label || code || "Unknown";
}

export function formatDuration(minutes?: number): string {
  if (!minutes) return "N/A";
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}h${mins > 0 ? ` ${mins}m` : ""}`;
}

export function formatTime(timeString?: string): string {
  if (!timeString) return "N/A";
  // Extract HH:MM by removing timezone info and taking first 5 chars
  const formatted = timeString.replace(/[+-]\d{2}:?\d{2}$/, "").slice(0, 5);
  console.log("Formatting time:", timeString, "to", formatted);
  return formatted;
}

export function shouldShowAlternateItinerary(
  userDeparture?: string | null,
  userArrival?: string | null,
  groupLegDescription?: {
    departureLocation?: string | null;
    arrivalLocation?: string | null;
  } | null,
): { show: boolean; text?: string } {
  if (!groupLegDescription) return { show: false };

  const uDep = (userDeparture || "").trim().toUpperCase();
  const uArr = (userArrival || "").trim().toUpperCase();
  const gDep = (groupLegDescription.departureLocation || "")
    .trim()
    .toUpperCase();
  const gArr = (groupLegDescription.arrivalLocation || "").trim().toUpperCase();

  if (!gDep && !gArr) return { show: false };

  // If both match user request exactly -> not alternate
  if (uDep && uArr && uDep === gDep && uArr === gArr) {
    return { show: false };
  }

  // Derive message based on which side differs
  if (uDep && uDep === gDep && gArr && gArr !== uArr) {
    return { show: true, text: `Alternate itinerary — arrives at ${gArr}` };
  }

  if (uArr && uArr === gArr && gDep && gDep !== uDep) {
    return { show: true, text: `Alternate itinerary — departs from ${gDep}` };
  }

  // Both different or user values missing -> show both codes if available
  if (gDep && gArr) {
    return { show: true, text: `Alternate itinerary — ${gDep} → ${gArr}` };
  }

  // If partial data, avoid showing unknown UI
  return { show: false };
}
